import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Button,
  Typography,
  Box,
  IconButton,
  FormGroup,
  FormControlLabel,
  Autocomplete,
} from "@mui/material";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import LoaderBackdrop from "../../Components/Loader/LoaderBackdrop";
import CardHeadMenu from "../../Components/Card/CardHeadMenu/CardHeadMenu";
import SaveIcon from "@mui/icons-material/Save";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import UpdateIcon from "@mui/icons-material/Update";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import IOSSwitch from "../../Components/Buttons/IOSSwitch";
import configServ from "../../services/config";
import Quill from "quill";
import Swal from "sweetalert2";
import KuldeviAdditionTable from "./KuldeviAdditionTable";
const KuldeviAddition = () => {
  const { company_id, user_id } = useSelector((state) => state.GlobalVariables);
  const [backDrowLoading, setBackDrowLoading] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [images, setImages] = useState([]);
  const [podcastUser, setPodcastUser] = useState([]);
  const [kuldeviList, setKuldeviList] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);

  const [formData, setFormData] = useState({
    title: "",
    kuldevi_id: "",
    author_id: "",
    about_kuldevi: "",
    active: true,
    photos: [],
  });
  const [validationErrors, setValidationErrors] = useState({});

  const handlePopup = () => {
    setIsCreate(!isCreate);
    setIsEdit(false);
    clear();
  };

  // 🔹 Convert file to Base64
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

  // 🔹 Upload Images (max 4)
  const handleImageUpload = async (e) => {
    const files = Array.from(e.target.files);
    const newImages = [];

    for (let file of files) {
      if (file.size > 5 * 1024 * 1024) {
        alert(`${file.name} exceeds 5MB limit.`);
        continue;
      }
      const base64 = await toBase64(file);
      newImages.push(base64);
    }

    const updated = [...images, ...newImages].slice(0, 4);
    setImages(updated);
    setFormData((prev) => ({ ...prev, photos: updated }));
  };

  // 🔹 Delete one image
  const handleDeleteImage = (index) => {
    const updated = images.filter((_, i) => i !== index);
    setImages(updated);
    setFormData((prev) => ({ ...prev, photos: updated }));
  };

  // 🔹 Handle field change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const clear = () => {
    setFormData({
      title: "",
      kuldevi_id: "",
      author_id: "",
      about_kuldevi: "",
      active: true,
      photos: [],
    });
    setImages([]);
    setValidationErrors({});

    setIsEdit(false);
  };

  const handleSubmit = async () => {
    // console.log("Form Data Submitted:", formData);
    const errors = {};

    // 🔹 Validation
    if (!formData.title?.trim()) {
      errors.title = "Title is required";
    }

    if (!formData.kuldevi_id) {
      errors.kuldevi_id = "Please select a Kuldevi";
    }

    if (!formData.author_id) {
      errors.author_id = "Please select an Author";
    }

    //   if (!formData.about_kuldevi?.trim()) {
    //     errors.about_kuldevi = "About Kuldevi is required";
    //   }

    // If any validation fails → show errors and stop
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    // Clear previous errors
    setValidationErrors({});
    setBackDrowLoading(true);

    try {
      let res;

      // 🔹 For Edit
      if (isEdit) {
        res = await configServ.updateKuldeviDetails({
          ...formData,
          company_id,
          updated_by: user_id,
        });
      }
      // 🔹 For Create
      else {
        res = await configServ.storeKuldeviDetails({
          ...formData,
          company_id,
          created_by: user_id,
        });
      }

      // 🔹 On Success
      if (res.status) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: res.message || (isEdit ? "Kuldevi updated!" : "Kuldevi added!"),
          timer: 2000,
          showConfirmButton: false,
        });

        clear();
        setIsCreate(false);
        fetchKuldeviTable(); // 🔁 Refresh table or list
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "Something went wrong!",
      });
    } finally {
      setBackDrowLoading(false);
    }
  };

  // ✅ Add English + Hindi font families
  const Font = Quill.import("formats/font");
  Font.whitelist = [
    "sans-serif",
    "serif",
    "monospace",
    "noto-sans-devanagari",
    "tiro-devanagari-hindi",
    "kalam",
  ];
  Quill.register(Font, true);

  // 🔹 Quill Config
  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      [{ font: Font.whitelist }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ align: [] }],
      ["link", "image", "video"],
      ["clean"],
    ],
  };

  const quillFormats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "list",
    "bullet",
    "indent",
    "align",
    "link",
    "image",
    "video",
  ];

  // 🔹 Dummy Data for dropdowns (later API-based)

  const fetchPodcastUser = async () => {
    try {
      setBackDrowLoading(true);
      const res = await configServ.getResourceMasterUserByCompany(company_id);
      if (res.success) {
        setPodcastUser(res.data); // make sure you have state: const [podcastList, setPodcastList] = useState([]);
      } else {
        console.error("Failed to fetch podcasts:", res.data.message);
      }
    } catch (error) {
      console.error("API error:", error);
    } finally {
      setBackDrowLoading(false);
    }
  };

  const fetchKuldeviList = async () => {
    try {
      setBackDrowLoading(true);
      const res = await configServ.getKuldeviList({ id: company_id });
      if (res.status) {
        setKuldeviList(res.data); // make sure you have state: const [podcastList, setPodcastList] = useState([]);
      } else {
        console.error("Failed to fetch podcasts:", res.data.message);
      }
    } catch (error) {
      console.error("API error:", error);
    } finally {
      setBackDrowLoading(false);
    }
  };
  useEffect(() => {
    if (isCreate) {
      fetchPodcastUser();
      fetchKuldeviList();
    }
  }, [isCreate]);

  const highlightMatch = (text, query) => {
    try {
      const words = query.toLowerCase().split(" ").filter(Boolean);
      const regex = new RegExp(`(${words.join("|")})`, "gi");

      return text.split(regex).map((part, index) =>
        words.includes(part.toLowerCase()) ? (
          <mark key={index} style={{ backgroundColor: "#ffe58f" }}>
            {part}
          </mark>
        ) : (
          <React.Fragment key={index}>{part}</React.Fragment>
        )
      );
    } catch (e) {
      console.error("Error in highlightMatch:", e);
      return text;
    }
  };

  const handleEdit = async (item) => {
    try {
      //   console.log("onEdit =", item);
      window.scrollTo({ top: 0, behavior: "smooth" });

      setIsCreate(true);
      setIsEdit(true);

      // Step 1️⃣ — Fetch Kuldevi Photos by kuldevi_details_id
      const res = await configServ.getKuldeviPhotos({
        kuldevi_details_id: item.id,
      });

      // Step 2️⃣ — Extract only Base64 strings
      let base64Images = [];
      if (res?.status && Array.isArray(res.data)) {
        base64Images = res.data
          .map((img) => img.base64_image)
          .filter((img) => !!img); // remove null/undefined
      }

      // Step 3️⃣ — Update both states
      setImages(base64Images); // For UI preview
      setFormData({
        id: item.id,
        title: item.title || "",
        kuldevi_id: item.kuldevi_id || "",
        author_id: item.author_id || "",
        about_kuldevi: item.about_kuldevi || "",
        active: item.active === 1 || item.active === true ? true : false,
        photos: base64Images, // 👈 Store only Base64 strings
      });

    //   console.log("Edited formData =>", {
    //     id: item.id,
    //     title: item.title,
    //     kuldevi_id: item.kuldevi_id,
    //     author_id: item.author_id,
    //     about_kuldevi: item.about_kuldevi,
    //     active: item.active,
    //     photos: base64Images,
    //   });
    } catch (error) {
      console.error("Error fetching Kuldevi photos:", error);
    }
  };

  const fetchKuldeviTable = () => {
    setRefreshKey((prev) => prev + 1); // trigger child refresh
  };

  return (
    <>
      <LoaderBackdrop open={backDrowLoading} />
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Kuldevi Details Page"}
        handlePopup={handlePopup}
        create={isCreate}
        isEdit={isEdit}
      />

      {isCreate && (
        <motion.div
          style={{
            width: "100%",
            backgroundColor: "#e3f3fc",
            padding: 20,
            borderRadius: "10px",
          }}
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.1, delay: 0.1 }}
        >
          <Grid container spacing={2}>
            {/* 🟦 Title */}
            <Grid item xs={12} md={4}>
              <TextField
                fullWidth
                size="small"
                label="Title"
                name="title"
                onChange={handleChange}
                value={formData.title}
                sx={{ backgroundColor: "white" }}
                error={!!validationErrors.title}
                helperText={validationErrors.title}
              />
            </Grid>

            {/* 🟩 Kuldevi Autocomplete */}
            <Grid item xs={12} md={4}>
              <Autocomplete
                disablePortal
                fullWidth
                size="small"
                id="kuldevi_id"
                name="kuldevi_id"
                options={kuldeviList}
                getOptionLabel={(option) => option.name || ""}
                filterOptions={(options, { inputValue }) => {
                  const words = inputValue
                    .toLowerCase()
                    .split(" ")
                    .filter(Boolean);
                  return options.filter((item) =>
                    words.every((word) =>
                      item.name.toLowerCase().includes(word)
                    )
                  );
                }}
                sx={{ background: "white" }}
                value={
                  kuldeviList.find((item) => item.id === formData.kuldevi_id) ||
                  null
                }
                onChange={(event, newValue) => {
                  if (newValue) {
                    setFormData((prev) => ({
                      ...prev,
                      kuldevi_id: newValue.id,
                    }));
                  }
                }}
                renderInput={(params) => {
                  const inputValue = params.inputProps.value || "";
                  const doesNotMatchOption =
                    inputValue &&
                    !kuldeviList.some((item) =>
                      inputValue
                        .toLowerCase()
                        .split(" ")
                        .filter(Boolean)
                        .every((word) => item.name.toLowerCase().includes(word))
                    );

                  return (
                    <Box display="flex" alignItems="center" width="100%">
                      <TextField
                        {...params}
                        label="Select Kuldevi"
                        name="kuldevi_id"
                        error={!!validationErrors.kuldevi_id}
                        fullWidth
                      />
                      {/* {doesNotMatchOption && (
                        <IconButton
                          color="primary"
                          onClick={() => navigate("/kuldevi-master")}
                        >
                          <AddCircleIcon />
                        </IconButton>
                      )} */}
                    </Box>
                  );
                }}
                renderOption={(props, option, { inputValue }) => (
                  <li {...props}>
                    <Typography variant="body2">
                      {highlightMatch(option?.name, inputValue)}
                    </Typography>
                  </li>
                )}
              />
            </Grid>

            {/* 🟨 Author Autocomplete */}
            <Grid item xs={12} md={4}>
              <Autocomplete
                disablePortal
                fullWidth
                size="small"
                id="author_id"
                name="author_id"
                options={podcastUser}
                getOptionLabel={(option) => option.name || ""}
                filterOptions={(options, { inputValue }) => {
                  const words = inputValue
                    .toLowerCase()
                    .split(" ")
                    .filter(Boolean);
                  return options.filter((item) =>
                    words.every((word) =>
                      item.name.toLowerCase().includes(word)
                    )
                  );
                }}
                sx={{ background: "white" }}
                value={
                  podcastUser.find((item) => item.id === formData.author_id) ||
                  null
                }
                onChange={(event, newValue) => {
                  if (newValue) {
                    setFormData((prev) => ({
                      ...prev,
                      author_id: newValue.id,
                    }));
                  }
                }}
                renderInput={(params) => {
                  const inputValue = params.inputProps.value || "";
                  const doesNotMatchOption =
                    inputValue &&
                    !podcastUser.some((item) =>
                      inputValue
                        .toLowerCase()
                        .split(" ")
                        .filter(Boolean)
                        .every((word) => item.name.toLowerCase().includes(word))
                    );

                  return (
                    <Box display="flex" alignItems="center" width="100%">
                      <TextField
                        {...params}
                        label="Select Author"
                        name="author_id"
                        error={!!validationErrors.author_id}
                        fullWidth
                      />
                    </Box>
                  );
                }}
                renderOption={(props, option, { inputValue }) => (
                  <li {...props}>
                    <Typography variant="body2">
                      {highlightMatch(option?.name, inputValue)}
                    </Typography>
                  </li>
                )}
              />
            </Grid>

            {/* 🟧 About Kuldevi (ReactQuill) */}
            <Grid item xs={12}>
              <label
                style={{
                  fontSize: "14px",
                  fontWeight: 500,
                  marginBottom: "4px",
                  display: "block",
                }}
              >
                Traveller Blog
              </label>
              <ReactQuill
                theme="snow"
                value={formData.about_kuldevi}
                onChange={(value) =>
                  setFormData((prev) => ({
                    ...prev,
                    about_kuldevi: value,
                  }))
                }
                modules={quillModules}
                formats={quillFormats}
                style={{
                  backgroundColor: "white",
                  minHeight: "300px",
                  maxHeight: "600px",
                  overflowY: "auto",
                }}
              />
            </Grid>

            {/* 🖼 Multiple Image Upload (Max 4) */}
            <Grid item xs={12}>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                Upload Photos (max 4)
              </Typography>

              <Box display="flex" flexWrap="wrap" gap={2}>
                {images.map((img, idx) => (
                  <Box key={idx} position="relative">
                    <img
                      src={img}
                      alt={`upload-${idx}`}
                      width={100}
                      height={100}
                      style={{
                        borderRadius: 8,
                        objectFit: "cover",
                        border: "1px solid #ccc",
                      }}
                    />
                    <IconButton
                      size="small"
                      color="error"
                      sx={{
                        position: "absolute",
                        top: -10,
                        right: -10,
                        background: "white",
                      }}
                      onClick={() => handleDeleteImage(idx)}
                    >
                      ✕
                    </IconButton>
                  </Box>
                ))}

                {images.length < 4 && (
                  <Button
                    variant="outlined"
                    component="label"
                    sx={{ width: 100, height: 100, borderRadius: 2 }}
                  >
                    +
                    <input
                      type="file"
                      accept="image/*"
                      hidden
                      multiple
                      onChange={handleImageUpload}
                    />
                  </Button>
                )}
              </Box>
            </Grid>

            {/* 🔘 Active Switch */}
            <Grid item xs={12} md={3}>
              <FormGroup row>
                <FormControlLabel
                  control={
                    <IOSSwitch
                      checked={formData.active}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          active: e.target.checked,
                        }))
                      }
                      name="active"
                    />
                  }
                  label="Active"
                />
              </FormGroup>
            </Grid>
          </Grid>

          {/* Buttons */}
          <Grid container spacing={2} justifyContent="flex-end" mt={2}>
            <Grid item>
              <Button
                onClick={clear}
                variant="contained"
                color="secondary"
                startIcon={<RotateLeftIcon />}
              >
                Reset
              </Button>
            </Grid>
            <Grid item>
              <Button
                onClick={handleSubmit}
                variant="contained"
                color={isEdit ? "success" : "primary"}
                startIcon={isEdit ? <UpdateIcon /> : <SaveIcon />}
              >
                {isEdit ? "Update" : "Save"}
              </Button>
            </Grid>
          </Grid>
        </motion.div>
      )}
      <KuldeviAdditionTable handleEdit={handleEdit} refreshKey={refreshKey} />
    </>
  );
};

export default KuldeviAddition;
